import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'modern-normalize/modern-normalize.css';
import './index.css';
import App from './App';
import { store, persistor } from './redux/contact/store';
import { BrowserRouter } from 'react-router-dom';
import Loader from './components/Loader';

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.Fragment>,
  document.querySelector('#root'),
);
